import { useState } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import cross from '~/assets/icons/cross.svg';
import discount from '~/assets/icons/discount.svg';
import { playSound, Sound } from '~/assets/sounds';
import { Layouts } from '~/shared';
import { TextLabel } from '../../components/TextLabel';
import {
	StyledBackground,
	StyledBackgroundWrapper,
	StyledCloseButton,
	StyledContainer,
	StyledContentContainer,
	StyledControlsButton,
	StyledControlsContainer,
	StyledDiscountBannerContainer,
	StyledDot,
	StyledDotsContainer,
	StyledOfferNameContainer,
	StyledTopContainer,
	StyledViewButton,
	StyledWrapper,
} from './Offers.styled';

const Offers = () => {
	const [index, setIndex] = useState(0);
	const maxIndex = 5;

	const handlePrev = () => {
		setIndex((prevState) => (prevState > 0 ? prevState - 1 : 0));
	};

	const handleNext = () => {
		setIndex((prevState) => (prevState < maxIndex ? index + 1 : prevState));
	};

	return (
		<StyledWrapper className={Layouts.Offers}>
			<StyledContainer>
				<StyledTopContainer>
					<TextLabel>Уникальные предложения</TextLabel>
					<StyledCloseButton
						onMouseEnter={() => playSound(Sound.LinkCursor)}
						onClick={() => {
							playSound(Sound.ClickButton);
						}}
					>
						<img src={cross} />
					</StyledCloseButton>
				</StyledTopContainer>
				<SwitchTransition>
					<CSSTransition
						timeout={500}
						classNames="container"
						key={index}
						addEndListener={(node, done) =>
							node.addEventListener('transitionend', done, false)
						}
					>
						<StyledContentContainer>
							<StyledBackgroundWrapper>
								<StyledBackground />
								<StyledDiscountBannerContainer>
									<img src={discount} />
									<TextLabel>
										Распродажа наборов с скидкой до{' '}
										<span style={{ fontWeight: 500 }}>50%!</span>
									</TextLabel>
								</StyledDiscountBannerContainer>
								<StyledOfferNameContainer>
									<TextLabel style={{ fontSize: 22 }}>
										<span style={{ fontWeight: 700 }}>BMW M4 CSL</span>{' '}
										<span style={{ fontWeight: 300, opacity: 0.5 }}>x</span>{' '}
										<span style={{ fontWeight: 700 }}>BMW M3 CS</span>
									</TextLabel>
									<TextLabel style={{ fontSize: 16, opacity: 0.5 }}>
										Уникальный винил + Красные детали
									</TextLabel>
								</StyledOfferNameContainer>
							</StyledBackgroundWrapper>
							<StyledViewButton
								onMouseEnter={() => playSound(Sound.LinkCursor)}
								onClick={() => {
									playSound(Sound.ClickButton);
								}}
								tabIndex={-1}
							>
								Узнать подробнее
							</StyledViewButton>
						</StyledContentContainer>
					</CSSTransition>
				</SwitchTransition>
				<StyledControlsContainer>
					<StyledControlsButton
						onClick={() => {
							handlePrev();
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
						tabIndex={-1}
					>
						Назад
					</StyledControlsButton>
					<StyledDotsContainer>
						{new Array(maxIndex + 1).fill(0).map((_, i) => (
							<StyledDot $selected={i === index} key={i} />
						))}
					</StyledDotsContainer>
					<StyledControlsButton
						onClick={() => {
							handleNext();
							playSound(Sound.ClickButton);
						}}
						onMouseEnter={() => playSound(Sound.LinkCursor)}
						tabIndex={-1}
					>
						Далее
					</StyledControlsButton>
				</StyledControlsContainer>
			</StyledContainer>
		</StyledWrapper>
	);
};

export { Offers };
